import {
    GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS, GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS, GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE,
    ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS, ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE,
    EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS, EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS, EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE,

    RESET_MESSAGE,
    UPLOAD_FILE_ATTACHMENT_PROGRESS,
    UPLOAD_FILE_ATTACHMENT_SUCCESS,
    UPLOAD_FILE_ATTACHMENT_FAILURE,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE,
    GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    customer_supplier_payment: [],
    customer_supplier_pending_payment: [],
    fileAttachment: "",
    loginUser: null,
    error: false,
    loading: false,
    message: null,
}

const customer_supplier_payment_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS:
            return { ...state, customer_supplier_payment: action.customer_supplier_payment, loading: false };
        case GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS:
            return { ...state, customer_supplier_payment: [...state.customer_supplier_payment, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS:
            return {
                ...state,
                customer_supplier_payment: state.customer_supplier_payment.map((customer_supplier_payment) =>
                    customer_supplier_payment.id === action.payload.id ? action.payload : customer_supplier_payment
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case UPLOAD_FILE_ATTACHMENT_PROGRESS:
            return { ...state, loading: true };
        case UPLOAD_FILE_ATTACHMENT_SUCCESS:
            return { ...state, fileAttachment: action.payload.result || "", loading: false, error: false, };
        case UPLOAD_FILE_ATTACHMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS:
            return { ...state, customer_supplier_pending_payment: action.customer_supplier_pending_payment, loading: false };
        case GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default customer_supplier_payment_reducer;